import { testimonials } from "@/mocks/gossip";
import SectionHeading from "@/components/base/SectionHeading";

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50" aria-labelledby="voice-heading">
      <SectionHeading
        kicker="Reader Voice"
        title="读者怎么说"
        desc="来自站内读者与内容从业者的真实反馈，也是我们持续整理下去的理由。"
        align="center"
      />
      <h2 id="voice-heading" className="sr-only">
        读者口碑
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex flex-col h-full p-5 md:p-6 bg-background-50 border border-background-200 rounded-lg"
          >
            <i className="ri-double-quotes-l text-2xl text-accent-400 mb-3"></i>
            <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
              {item.text}
            </blockquote>
            <figcaption className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center text-sm font-label font-bold">
                {item.name.slice(0, 1)}
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-label text-sm font-medium text-foreground-950">{item.name}</span>
                <span className="font-label text-[11px] text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}